function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

function SvgApprove(props) {
  const light = props.light || '#999';
  const dark = props.dark || '#000';
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 96 96",
    "uc-svg": "www"
  }, props), React.createElement("path", {
    d: "M90.866 70.678l-.003-23.63-2.733-.666c-6.207-1.511-14.579-5.451-14.154-8.916.323-2.623 2.454-4.349 5.669-6.683 3.157-2.291 7.48-5.429 5.831-10.65C81.867 8.701 54.873 8.433 49.419 8.87c-4.085-.056-11.939.557-18.97 1.766-14.38 2.471-17.206 5.895-18.06 8.601-1.649 5.221 2.674 8.36 5.831 10.651 3.216 2.334 5.347 4.06 5.669 6.682.425 3.466-7.946 7.405-14.149 8.916L7 46.149v25.949h.04c-.017.198-.04.395-.04.597C7 83.05 28.814 87.767 49.082 87.767s42.082-4.716 42.082-15.072a7.057 7.057 0 00-.298-2.017zm-41.784 9.926c-21.381 0-33.582-5.125-34.817-7.611h-.214V54.526h.112v-2.849c5.779-1.816 17.967-6.769 16.836-15.98-.726-5.912-5.261-9.203-8.571-11.606-1.101-.799-2.719-1.974-3.15-2.632 3.018-2.913 22.327-5.741 30.595-5.413l.001-.028c13.086-1.215 27.574 3.024 28.762 6.254-.339.639-2.05 1.88-3.198 2.714-3.31 2.403-7.845 5.694-8.571 11.607-1.131 9.21 11.057 14.164 16.836 15.98V72.993h.188c-1.278 2.507-13.471 7.611-34.809 7.611z"
  }), React.createElement("path", {
    fill: "none",
    stroke: dark,
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M18 54.5s28 16.5 59 0"
  }));
}

SvgApprove.clsName = 'icon-www__approve';
SvgApprove.remarkName = 'unknown';
export default SvgApprove;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud/ucloud-icons/dist/www/svgr/Approve.js
// module id = 2276
// module chunks = 17 18